import { Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";

const gradient =
  "linear-gradient(90deg, #CF3E00 0%, #FE8836 25%, #FBDB14 50%, #A7C933 75%, #27AE60 100%)";

export const Progress = ({
  primaryValue,
  secondaryValue,
  height = "20px",
}: {
  primaryValue: number;
  secondaryValue: number;
  height?: string;
}) => {
  const [progressWidth, setProgressWidth] = useState<number>(0);
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const value = primaryValue + secondaryValue;

  useEffect(() => {
    if (wrapperRef.current)
      setProgressWidth(wrapperRef.current.clientWidth - 1);
  }, []);

  return (
    <Box
      ref={wrapperRef}
      sx={{
        height,
        backgroundColor: "#F7F7F7",
        borderRadius: "8px",
        overflow: "hidden",
        width: "100%",
      }}
    >
      <Box
        sx={{
          height,
          maxWidth: `${value}%`,
          overflow: "hidden",
          borderRadius: "8px",
          transition: "max-width 0.3s ease",
        }}
      >
        <Box
          sx={{
            height,
            width: `${progressWidth}px`,
            borderRadius: "8px",
            backgroundImage: gradient,
          }}
        />
      </Box>
    </Box>
  );
};
